import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';
import defaultReplication from '@/rxdb/defaultReplication';

export const preparationVisas = {
    schema: {
        title: 'preparationVisas schema',
        version: 1,
        description: 'describes a preparationVisa',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: { type: 'string', final: true, maxLength: 40 },
            preparationId: { type: ['string', 'null'] },
            conclusion: { type: ['string', 'null'] },
            emissionDueDate: { type: ['string', 'null'] },
            emissionDate: { type: ['string', 'null'] },
            emitterId: { type: ['string', 'null'] },
            url: { type: ['string', 'null'] },
            comments: { type: ['string', 'null'] },
            generationStartDate: { type: ['string', 'null'] },
            generationEndDate: { type: ['string', 'null'] },
            generationSucceed: { type: ['boolean', 'null'] },
            attachments: {
                type: ['array', 'null'],
                items: {
                    type: 'object',
                    properties: {
                        url: { type: 'string' },
                        fileName: { type: 'string' },
                    },
                },
            },
            createdBy: { type: ['string', 'null'], final: true },
            updatedAt: { type: ['string', 'null'] },
            deletedAt: { type: ['string', 'null'] },
            deletedBy: { type: ['string', 'null'] },
            createdAt: { type: ['string', 'null'] },
            updatedBy: { type: ['string', 'null'] },
            projectId: { type: ['string', 'null'] },
            rootVersion: { type: ['string', 'null'] },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {
        1: (doc) => doc,
    },
};
